var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{style:('height: ' + _vm.data.height),attrs:{"no-gutters":_vm.noGutters,"align":"center","justify":"center"}},[_c('v-progress-circular',{staticClass:"gray-color",attrs:{"indeterminate":"","width":"1","size":"50"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }